var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bubbles_wrapper", attrs: { "data-chart": "bubbles" } },
    _vm._l(_vm.bubblesArray, function(bubbleObj, bubbleKey) {
      return _c("div", { staticClass: "bubble_container" }, [
        _c(
          "div",
          {
            staticClass: "bubble",
            style: {
              width: bubbleObj.size + "px",
              height: bubbleObj.size + "px"
            }
          },
          [
            _vm.bubblesTooltips[bubbleObj.label] != undefined
              ? _c("div", { staticClass: "bubble_tooltip" }, [
                  _c("div", { staticClass: "tooltip_title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.bubblesTooltips[bubbleObj.label].title) +
                        "\n                "
                    )
                  ]),
                  _c("div", { staticClass: "tooltip_source" }, [
                    _c("i", [_vm._v("Data Source : ")]),
                    _vm._v(
                      _vm._s(_vm.bubblesTooltips[bubbleObj.label].source) +
                        "\n                "
                    )
                  ]),
                  _c("div", { staticClass: "tooltip_type" }, [
                    _c("i", [_vm._v("Data Type : ")]),
                    _vm._v(
                      _vm._s(_vm.bubblesTooltips[bubbleObj.label].type) +
                        "\n                "
                    )
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "bubble_label" }, [
              _vm._v(
                "\n                " +
                  _vm._s(bubbleObj.label) +
                  "\n                "
              ),
              _vm.indicatorUnit != "%"
                ? _c("div", { staticClass: "bubble_value" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(bubbleObj.value.toFixed(0)) +
                        " " +
                        _vm._s(_vm.indicatorUnit) +
                        "\n                "
                    )
                  ])
                : _c("div", { staticClass: "bubble_value" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(bubbleObj.value.toFixed(3)) +
                        " " +
                        _vm._s(_vm.indicatorUnit) +
                        "\n                "
                    )
                  ])
            ])
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77d73b62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d73b62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/bubblesGraph.vue
// module id = TBNF
// module chunks = 0